/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExclamationInTriangleSolidIcon = createIcon("ExclamationInTriangleSolidIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.759 20.418-9.885-18.79A2.116 2.116 0 0012 .5c-.787 0-1.509.435-1.874 1.128L.241 20.418a2.097 2.097 0 00.065 2.067 2.117 2.117 0 001.81 1.015h19.769a2.12 2.12 0 001.81-1.015c.383-.63.407-1.415.064-2.067ZM10.943 8.23c0-.581.473-1.052 1.057-1.052s1.057.471 1.057 1.052v6.316c0 .582-.473 1.053-1.057 1.053a1.055 1.055 0 01-1.057-1.053V8.231Zm1.11 12.116h-.03a1.612 1.612 0 01-1.61-1.547 1.55 1.55 0 01.427-1.125 1.564 1.564 0 011.105-.486h.03a1.612 1.612 0 011.611 1.545c.017.417-.136.824-.425 1.128a1.563 1.563 0 01-1.108.485Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});